<template>

<app-content :loading="is.loading">

	<app-content-head :title="title" :back="$route.meta.back" :readonly="$authorised('mem/pricing/access', 'read')">

		<app-content-head-actions-item :disabled="!isDirty" icon="undo" text="Undo" v-on:click="onUndoClick" />
		<app-content-head-actions-item :loading="is.saving" :disabled="!isDirty || !isValid" icon="save" text="Save" v-on:click="onSaveClick" />
		<app-content-head-actions-item v-if="!isNew" :disabled="isNew" :danger="true" icon="delete" text="Delete" v-on:click="onDeleteClick" />

	</app-content-head>

	<app-content-body>

		<app-content-box :readonly="$authorised('mem/pricing/access', 'read')">

			<app-input-text label="Name" :maxlength="64" placeholder="Enter name..." v-model="model.name" :validation="$v.model.name" />
            <app-input-text label="Description" :autogrow="true" placeholder="Enter description..." v-model="model.description" :validation="$v.model.description" />
			<app-input-suggest :defaultValue="''" label="Type" placeholder="Search subscription types..." v-model="model.type" :validation="$v.model.type" api="membership/type" />
            <app-input-checklist :collapsed="!isNew" :fullWidth="true" :singular="true" :columns="1" label="Status" v-model="model.status" :validation="$v.model.status" :options="$constants.membership.plan.statusName" :descriptions="$constants.membership.plan.statusDescription" />
            <app-input-checklist :collapsed="!isNew" :fullWidth="true" :singular="true" :columns="1" label="Cycle" v-model="model.cycle" :validation="$v.model.cycle" :options="$constants.membership.subscription.billing.cycleName" :descriptions="$constants.membership.subscription.billing.cycleDescription" />
			<app-input-text label="Price" prefix="$" placeholder="Enter amount..." v-model="model.cost" :validation="$v.model.cost" />
			<app-input-text label="Limit" placeholder="Enter amount..." :toggle="model.quantity.enabled" notes="Set a maximum number that can be sold of this plan across all purchases." v-on:toggle="model.quantity.enabled = !model.quantity.enabled" v-model="model.quantity.amount" :validation="$v.model.quantity.amount" />
			<app-input-date :time="true" label="Available from" placeholder="Enter date..." :toggle="model.from.enabled" v-on:toggle="model.from.enabled = !model.from.enabled" v-model="model.from.date" :validation="$v.model.from.date" />
			<app-input-date :time="true" label="Available until" placeholder="Enter date..." :toggle="model.to.enabled" v-on:toggle="model.to.enabled = !model.to.enabled" v-model="model.to.date" :validation="$v.model.to.date" />
			
		</app-content-box>

	</app-content-body>

</app-content>

</template>

<script>

import mixForm from '@/mixin/form'
import { required, between, minLength } from 'vuelidate/lib/validators'

export default {

	mixins: [mixForm],

	data: function() {

		return {
			readonly: this.$authorised('mem/pricing/access', 'read'),
			references: {},
			model: {
				id: false,
				name: '',
                description: '',
                cost: 0,
                status: 1,
                type: false,
                cycle: 0,
                quantity: {
                    enabled: false,
                    amount: 0
                },
                from: {
                    enabled: false,
                    date: 0
                },
                to: {
                    enabled: false,
                    date: 0
                }
			}
		}

	},

	validations: {
		model: {
			name: {
				required
			},
            cost: {
                required
            },
            type: {
                required,
				minLength: minLength(8)
            },
            cycle: {
                required,
				between: between(1,5)
            },
            quantity: {},
            from: {},
            to: {}
		}
	},

	computed: {

	}

}

</script>

<style scoped>

</style>